module.exports = __webpack_public_path__ + "static/media/zoology.6871c008.png";